<template>
  <div class="pdf-viewer-native">
    <iframe
      v-for="i in resolvedPages"
      :key="`pdf-page-${i}`"
      :src="pageSrc(i)"
      class="pdf-frame"
      :style="frameStyle"
      title="PDF preview"
    />
  </div>
</template>
<script>
export default {
  name: 'PdfViewer',
  props: {
    src: {
      type: String,
      default: '',
    },
    numPages: {
      type: Number,
      default: 1,
    },
    rotate: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    resolvedPages() {
      // If numPages is not known yet, still render one frame for preview.
      return Math.max(parseInt(this.numPages, 10) || 1, 1);
    },
    frameStyle() {
      if (!this.rotate) {
        return {};
      }
      return {
        transform: `rotate(${this.rotate}deg)`,
        transformOrigin: 'top left',
      };
    },
  },
  methods: {
    pageSrc(page) {
      if (!this.src) {
        return '';
      }
      const separator = this.src.includes('#') ? '&' : '#';
      return `${this.src}${separator}page=${page}`;
    },
  },
  errorCaptured() {
    return false;
  },
};
</script>
<style scoped>
.pdf-viewer-native {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pdf-frame {
  width: 100%;
  min-height: 600px;
  border: 0;
  background: #fff;
}
</style>
